import styled from 'styled-components';

export const Content = styled.div`
  padding-bottom: 32px;
  padding-top: 32px;
`;
